import { useFocusEffect, useLocalSearchParams } from 'expo-router';
import { useSetAtom } from 'jotai/index';
import { useCallback, useEffect } from 'react';

import { selectedMembershipIdAtom } from '../../../../../entities/entityAtoms';
import MoneyMapPreviewPageWithHeader from '../../../../../money-map/components/MoneyMapPreviewPageWithHeader';
import { MoneyMapAccountsProvider } from '../../../../../money-map/providers/MoneyMapAccountsProvider';

const MoneyMapPreviewPage = () => {
    const { membershipId, moneyMapId } = useLocalSearchParams<{
        membershipId: string;
        moneyMapId: string;
    }>();

    const setSelectedMembershipId = useSetAtom(selectedMembershipIdAtom);

    // This effect will only run once per membership because each membership details page
    // is rendered separately in a navigation stack (thus, going back to previously viewed
    // memberships is fast)
    useEffect(() => {
        setSelectedMembershipId(membershipId);
    }, [membershipId]);

    // This effect will run every time a membership is re-visited
    // so if the data fetch for this membership wasn't completed on the first visit,
    // this will trigger a new request for the data
    useFocusEffect(
        useCallback(() => {
            setSelectedMembershipId(membershipId);
        }, [membershipId]),
    );

    return (
        <MoneyMapAccountsProvider>
            <MoneyMapPreviewPageWithHeader moneyMapId={moneyMapId} />
        </MoneyMapAccountsProvider>
    );
};

export default MoneyMapPreviewPage;
